import { render, staticRenderFns } from "./CustomPayment-Accelerant-60.vue?vue&type=template&id=1beb3458&scoped=true&"
import script from "./CustomPayment-Accelerant-60.vue?vue&type=script&lang=js&"
export * from "./CustomPayment-Accelerant-60.vue?vue&type=script&lang=js&"
import style0 from "./CustomPayment-Accelerant-60.vue?vue&type=style&index=0&id=1beb3458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beb3458",
  null
  
)

export default component.exports